export const slug = {
    labels: {
        slug: "Slug",
        slugs: "Slugs",
        is_main: "Principal",
        language: "Idioma",
        add_slug: "Adicionar Slug",
    },
    placeholders: {
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_slug: "Adicionar Slug",
        },
        messages: {
            del_slug: "Você deseja mesmo excluir o slug <strong>{name}</strong>?<br/>Essa operação não pode ser desfeita.",
        },
    },
    texts: {
        empty: "Nenhum há slugs para exibir.",
        add_slug: "Deseja adicionar um slug para este item?",
    },
};
